import { render, staticRenderFns } from "./knowdetail.vue?vue&type=template&id=79f6c133"
import script from "./knowdetail.vue?vue&type=script&lang=js"
export * from "./knowdetail.vue?vue&type=script&lang=js"
import style0 from "./knowdetail.vue?vue&type=style&index=0&id=79f6c133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports